export const GA_TRACKING_ID = "G-Z00TJJQWG9";

// Track page views
export const pageview = (url) => {
  window.gtag("config", GA_TRACKING_ID, {
    page_path: url,
  });
};